export const infoTexts = [
    {
        title: 'Sankhya ID e LGPD',
        texts: [
            'O Sankhya ID coleta o nome, sobrenome, CPF, data de nascimento e e-mail inseridos ativamente por você com a única finalidade de identificação da sua “conta" para eventuais atividades que venha a realizar nas soluções Sankhya.',
            'Posto isto, não se preocupe, os seus dados estão seguros e serão utilizados especificamente para lhe oferecer uma melhor experiência de uso das aplicações Sankhya.',
            'Ressalta-se que o Sankhya ID não coleta dados sensíveis dos usuários.'
        ]
    },
    {
        title: 'Com quem compartilhamos os dados',
        texts: [
            'O Sankhya ID está em conformidade com a Lei Geral de Proteção de Dados - LGPD e reforça que não há compartilhamento dos dados com terceiros de qualquer forma. Sendo assim, os seus dados pessoais não serão compartilhados ou usados sem o seu consentimento para fins alheios ao ecossistema de aplicações Sankhya.'
        ]
    },
    {
        title: 'Retenção de informações coletadas',
        texts: [
            'As informações coletadas ficam retidas por tempo indeterminado, para as finalidades referidas acima, caso não deseje mais compartilhar seus dados, você deverá solicitar o esquecimento através do e-mail dpo@sankhya.com.br.',
            'Sem prejuízo, as informações poderão ser conservadas para cumprimento de obrigação legal ou regulatória, transferência a terceiro – desde que respeitados os requisitos de tratamento de dados – e uso exclusivo da Sankhya, vedado seu acesso por terceiro, mesmo que anonimizadas.'
        ]
    },
];
